import React from 'react';
// import { Panel } from 'react-bootstrap';

import PurchaseOrder from './PurchaseOrder';

const Results = ({ activeCrew, locationEnabled, purchaseOrders, onPurchaseOrderClick, ...props }) => (
  <div className="panel panel-default" {...props}>
    <div className="panel-body">
      {purchaseOrders.map((p) => (
        <PurchaseOrder
          activeCrew={activeCrew}
          locationEnabled={locationEnabled}
          purchaseOrder={p}
          key={p.id}
          onClick={() => onPurchaseOrderClick(p.id)}
        />
      ))}
    </div>
  </div>
);

export default Results;
